import React, { useEffect, useState } from 'react'
import { useReturnAllItems } from '../../features/items/itemsSlice'
import { IAxiosDefaultDataObject } from '../../config'
import BaseApp, { replaceItemDataInLink } from '../../features/BaseApp'
import { handleRequestError } from '../../services/api'
import { useDispatch } from 'react-redux'
import DataDisplayerOptionsModal from './DataDisplayerOptionsModal'
import BasicDataViewer, { BasicDataViewerItemTypes, IBasicDataViewItem } from './BasicDataViewer'
import { Button } from '@mui/material'
import { Link } from 'react-router-dom'

export interface IQuickItemViewBoxProps {
    shown: boolean,
    itemId: number,
    baseApp: BaseApp,
    handleHide: () => void,
    itemsList: () => Array<IAxiosDefaultDataObject>,
}

export default function QuickItemViewBox(props: IQuickItemViewBoxProps) {

    const dispatch = useDispatch()

    const itemsFromState = props.itemsList()

    const { itemId, baseApp, shown, handleHide } = props

    const [item, setItem] = useState<IAxiosDefaultDataObject>({})
    const [fields, setFields] = useState<Array<IBasicDataViewItem>>([])

    const isObjectEmpty = (obj: IAxiosDefaultDataObject) => Object.keys(obj).length === 0

    /**
     * Load item
     */
    const loadItemDetails = () => {
        if (itemId !== null){
            if (itemId !== 0){
                baseApp.singleInstanceDetails(itemId)
                    .then(response => {
                        setItem(response.data)
                    })
                    .catch(error => {
                        handleRequestError(error, dispatch)
                    })
            }
        }
    }

    useEffect(() => {

        if (itemsFromState.length > 0){
            let findItem: IAxiosDefaultDataObject = {}

            itemsFromState.map((singleItem) => {
                if (singleItem.id === itemId){
                    findItem = singleItem
                }
            })

            if (!isObjectEmpty(findItem)){
                setItem(findItem)
            }else{
                loadItemDetails()
            }

        }else{
            loadItemDetails()
        }

    }, [itemId])

    useEffect(() => {

        if (baseApp.dataDisplayer.columns){

            let fieldsList: Array<IBasicDataViewItem> = []

            baseApp.dataDisplayer.columns.map((column) => {
                if (column.type !== "thumbnail"){
                    fieldsList.push({
                        type:  column.type as BasicDataViewerItemTypes,
                        label: column.label,
                        value: item[column.id],
                        displayLabelNextLine: true
                    })
                }
            })

            setFields(fieldsList)
        }

    }, [item])

    return (
        <DataDisplayerOptionsModal title="Details" shown={shown} hideModal={handleHide}>
            <BasicDataViewer items={fields} />
            <Link to={replaceItemDataInLink(`/panel/${baseApp.appName}/view/[id]`, item)}><Button className="general-button admin-style" fullWidth variant='outlined'>View</Button></Link>
        </DataDisplayerOptionsModal>
    )
}